import Vue from 'vue'

import Vuex from 'vuex'
import { baseUrl } from '@/config/index.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: ['banner', 'docunmentList'] // 添加docunmentList到持久化路径
        })
    ],
    state: {
        baseUrl: baseUrl,
        banner: JSON.parse(localStorage.getItem('banner')) || [],
        footerObj: {},
        docunmentList: JSON.parse(localStorage.getItem('docunmentList')) || [], // 初始化时读取本地存储
        caseList:[],
        dynamic:[],
        solve:[],
        product:[],
        screenWidth: 0 // 屏幕宽度
    },
    mutations: {
        setScreenWidth(state, width) {
            state.screenWidth = width; // 更新屏幕宽度 
        },
        setBanner: (state, payload) => {
            state.banner = payload
            localStorage.setItem('banner', JSON.stringify(payload))
        },
        setDocument: (state, payload) => {
            state.docunmentList = payload
            localStorage.setItem('docunmentList', JSON.stringify(payload)) // 保存到本地存储
        },
        setCase:(state,payload) => {
            state.caseList = payload
        },
        setDynamic:(state,payload) => {
            state.dynamic = payload
        },
        setSolve:(state,payload) => {
            state.solve = payload
        },
        setProduct:(state,payload) => {
            state.product = payload
        },
    },
    getters: {},
    actions: {}
})
